import { ServiceOptionActionTypes } from "./constants";

export const serviceOptionApiResponseSuccess = ( actionType = '', data = {} ) => ({
    type: ServiceOptionActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data }
});

export const serviceOptionApiResponseError = ( actionType = '', data = {} ) => ({
    type: ServiceOptionActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data },
});

export const getServiceOption = (params) => {
    return {
        type: ServiceOptionActionTypes.GET_SERVICE_OPTION,
        payload: { params },
    }
};

export const resetServiceOption = () => {
    return {
        type: ServiceOptionActionTypes.RESET_SERVICE_OPTION,
        payload: {},
    }
}